import { useTranslation } from "react-i18next";
import BrandButton from "../brand-button";

const EmptyCart = () => {
    const { t, i18n } = useTranslation();  
    const continueShopping = i18n.exists("pages.continueShopping") ? t('pages.continueShopping') : "Продължи с пазаруването";
    const emtyCartLabel = i18n.exists("pages.emtyCartLabel") ? t('pages.emtyCartLabel') : "Нямате добавени артикули във Вашата количка.";
    return (
        <div className="empty-cart"> 
            <h2 className="align-center">{emtyCartLabel}</h2>
            <div className="align-center">
                <div className="m-top-40">
                    <img src="./img/empty-basket.svg" alt="basket" />
                </div>
                <div className="m-top-40">
                    <BrandButton isNavigateBtn={true} text={continueShopping} href='/' title={continueShopping} backgroundColor="#fff" classNameAttr="capitalize"/>
                </div>
            </div>
        </div>
    )
}

export default EmptyCart;